// TanStack query keys for the admins module. Hierarchical so that
// invalidating `lists()` after a write hits every list-shaped cache
// regardless of the filter args passed at fetch time.

import type { GetAdminsListParams } from '../types/adminTypes'

export const adminsQueryKeys = {
  all: ['admins'] as const,
  lists: () => [...adminsQueryKeys.all, 'list'] as const,
  list: (params: GetAdminsListParams) => [...adminsQueryKeys.lists(), params] as const,
  audits: () => [...adminsQueryKeys.all, 'audit'] as const,
  audit: (id: string) => [...adminsQueryKeys.audits(), id] as const,
}
